import { gql } from '@web/gql'
import { Filters_UserReviewGroupCategoryFragment, ReviewGroupsMediaFilter } from '@web/gql/graphql'

import Category from './Category/Category'
import MediaFilter from './MediaFilter/MediaFilter'

type Props = {
  mediaFilter: ReviewGroupsMediaFilter
  setMediaFilter: (mediaFilter: ReviewGroupsMediaFilter) => void
  categories: Filters_UserReviewGroupCategoryFragment[]
}

const Filters = ({ mediaFilter, setMediaFilter, categories = [] }: Props) => {
  return (
    <>
      <MediaFilter mediaFilter={mediaFilter} setMediaFilter={setMediaFilter} />
      <Category categories={categories} />
    </>
  )
}

export default Filters

Filters.fragments = gql(`
  fragment Filters_UserReviewGroupCategory on ReviewGroupCategory {
    ...Category_ReviewGroupCategory
  }
`)
